var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewSourcesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.102,
    x2: 0,
    y2: 0.91,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e87f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f68a6f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.266,
    y1: -0.294,
    x2: -0.296,
    y2: 1.173,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1376",
    "data-name": "Groupe 1376",
    transform: "translate(-142 -1341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_118",
    "data-name": "Trac\\xE9 118",
    d: "M1346.391-154.923a23.527,23.527,0,0,1-23.5-23.5,23.527,23.527,0,0,1,23.5-23.5,23.527,23.527,0,0,1,23.5,23.5A23.527,23.527,0,0,1,1346.391-154.923Zm0-45a21.524,21.524,0,0,0-21.5,21.5,21.524,21.524,0,0,0,21.5,21.5,21.525,21.525,0,0,0,21.5-21.5A21.525,21.525,0,0,0,1346.391-199.923Z",
    transform: "translate(-1180.891 1542.923)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_123",
    "data-name": "Trac\\xE9 123",
    d: "M9.458,7.178A1.3,1.3,0,0,0,7.542,5.422l-2.57,2.8L4.3,7.418a1.3,1.3,0,0,0-2,1.664l1.625,1.95a1.3,1.3,0,0,0,1.957.046ZM13.7,7.6a1.3,1.3,0,0,0,0,2.6h13a1.3,1.3,0,0,0,0-2.6ZM2,19.3a3.9,3.9,0,1,0,3.9-3.9A3.9,3.9,0,0,0,2,19.3Zm3.9,1.3a1.3,1.3,0,1,1,1.3-1.3A1.3,1.3,0,0,1,5.9,20.6ZM13.7,18a1.3,1.3,0,0,0,0,2.6h13a1.3,1.3,0,1,0,0-2.6Z",
    transform: "translate(151 1350.9)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSourcesIcon);
export default __webpack_public_path__ + "static/media/NewSourcesIcon.6379ada6dbbb1095976ab3dd65085ebe.svg";
export { ForwardRef as ReactComponent };